<template>
	<li class="nav-item" v-if="node.children && node.children.length">
		<router-link to="" class='nav-link nav-nav'>
			<i :class="'nav-icon ' + node.icon"></i>
			<p>
				{{ node.ten }}
				<i class="right fas fa-angle-left"></i>
			</p>
		</router-link>
		<!-- <router-link v-else to="#" class='nav-link'>
        <i :class="'nav-icon ' + node.icon"></i>
        <p>
          {{ node.ten }} 2
          <i class="right fas fa-angle-left"></i>
        </p>
      </router-link> -->
		<ul class="nav nav-treeview" v-if="node.children && node.children.length">
			<TheNodeTreeMenu v-for="menu in node.children" :key="menu.id" :node="menu"></TheNodeTreeMenu>
		</ul>
	</li>

	<li class="nav-item" v-else>
		<router-link v-if="!node.menuChaId" :to="node.duongDan ? node.duongDan : '/'" class='nav-link nav-nav'>
			<i :class="'nav-icon ' + node.icon"></i>
			<p>
				{{ node.ten }}
			</p>
		</router-link>
		<router-link v-else class='nav-link nav-nav' :to="node.duongDan ? node.duongDan : '/'">
			<i :class="'nav-icon ' + node.icon"></i>
			<p>
				{{ node.ten }}
			</p>
		</router-link>
	</li>

</template>

<script>
	import TheNodeTreeMenu from '@/components/dashboard/TheNodeTreeMenu.vue';

	export default {
		name: 'TheNodeTreeMenu',
		props: {
			node: Object
		},
		components: {
			TheNodeTreeMenu
		},
	};
</script>